import { InterventionReportAdvancedFilters } from '../pages/interventionReports/interventionReports.type';

export const hasActiveInterventionAdvancedFilters = (
  filters: InterventionReportAdvancedFilters,
): boolean => {
  return Boolean(
    filters.timeCreatedFrom ||
    filters.timeCreatedUntil ||
    filters.playerNo ||
    filters.gender ||
    filters.age ||
    filters.ethnicity ||
    (filters.interventionStatus && filters.interventionStatus.length > 0) ||
    filters.harmInstances ||
    (filters.harmObserved && filters.harmObserved.length > 0) ||
    (filters.actionTaken && filters.actionTaken.length > 0) ||
    filters.totalInterventionsOffered ||
    filters.totalInterventionsRequested ||
    filters.createdBy ||
    filters.reviewedBy ||
    filters.dateReviewedFrom ||
    filters.dateReviewedTo ||
    (filters.reviewStatus && filters.reviewStatus.length > 0) ||
    filters.compliance ||
    (filters.followUpActions && filters.followUpActions.length > 0),
  );
};
